export default "__VITE_ASSET__x$3M2_CN__"